import { Floorplan } from "@domain/project/floorplan/floorplan";
import { ScopedProject } from "../project-guards";

export enum FloorplanEventType {
  AIR_PATH_ADDED = "AIR_PATH_ADDED",
  AIR_PATH_DELETED = "AIR_PATH_DELETED",
  AIR_PATHS_ITEM_TEXT_VISIBILITY_CHANGED = "AIR_PATHS_ITEM_TEXT_VISIBILITY_CHANGED",
  ALARM_DEVICE_ADDED = "ALARM_DEVICE_ADDED",
  ALARM_DEVICE_DELETED = "ALARM_DEVICE_DELETED",
  ALARM_DEVICES_ITEM_TEXT_VISIBILITY_CHANGED = "ALARM_DEVICES_ITEM_TEXT_VISIBILITY_CHANGED",
  ALARM_DEVICE_PLACEHOLDER_ADDED = "ALARM_DEVICE_PLACEHOLDER_ADDED",
  ALARM_DEVICE_PLACEHOLDER_DELETED = "ALARM_DEVICE_PLACEHOLDER_DELETED",
  CABLE_ROUTE_ADDED = "CABLE_ROUTE_ADDED",
  CABLE_ROUTE_DELETED = "CABLE_ROUTE_DELETED",
  CABLE_ROUTES_ITEM_TEXT_VISIBILITY_CHANGED = "CABLE_ROUTES_ITEM_TEXT_VISIBILITY_CHANGED",
  COVERAGE_AREA_LENGTH_UPDATED = "COVERAGE_AREA_LENGTH_UPDATED",
  DANGER_AREA_ADDED = "DANGER_AREA_ADDED",
  DANGER_AREA_DELETED = "DANGER_AREA_DELETED",
  DANGER_AREAS_ITEM_TEXT_VISIBILITY_CHANGED = "DANGER_AREAS_ITEM_TEXT_VISIBILITY_CHANGED",
  DUST_EX_ZONE_ADDED = "DUST_EX_ZONE_ADDED",
  DUST_EX_ZONE_DELETED = "DUST_EX_ZONE_DELETED",
  DUST_EX_ZONES_ITEM_TEXT_VISIBILITY_CHANGED = "DUST_EX_ZONES_ITEM_TEXT_VISIBILITY_CHANGED",
  EX_ZONE_ADDED = "EX_ZONE_ADDED",
  EX_ZONE_DELETED = "EX_ZONE_DELETED",
  EX_ZONES_ITEM_TEXT_VISIBILITY_CHANGED = "EX_ZONES_ITEM_TEXT_VISIBILITY_CHANGED",
  FLAME_DETECTOR_ADDED = "FLAME_DETECTOR_ADDED",
  FLAME_DETECTOR_DELETED = "FLAME_DETECTOR_DELETED",
  FLAME_DETECTORS_ITEM_TEXT_VISIBILITY_CHANGED = "FLAME_DETECTOR_ITEM_TEXT_VISIBILITY_CHANGED",
  FLAME_DETECTOR_PLACEHOLDER_ADDED = "FLAME_DETECTOR_PLACEHOLDER_ADDED",
  FLAME_DETECTOR_PLACEHOLDER_DELETED = "FLAME_DETECTOR_PLACEHOLDER_DELETED",
  FLOORPLAN_DISPLAY_MODE_UPDATED = "FLOORPLAN_DISPLAY_MODE_UPDATED",
  FLOORPLAN_OPACITY_UPDATED = "FLOORPLAN_OPACITY_UPDATED",
  FLOORPLAN_SELECTION_MODE_UPDATED = "FLOORPLAN_SELECTION_MODE_UPDATED",
  FLOORPLAN_STATE_BORDER_SHAPE_UPDATED = "FLOORPLAN_STATE_BORDER_SHAPE_UPDATED",
  FLOORPLAN_STATE_LOCK_CHANGED = "FLOORPLAN_STATE_LOCK_CHANGED",
  FLOORPLAN_STATE_POSITION_UPDATED = "FLOORPLAN_STATE_POSITION_UPDATED",
  FLOORPLAN_STATE_SCALE_UPDATED = "FLOORPLAN_STATE_SCALE_UPDATED",
  FLOORPLAN_STATE_VISIBILITY_CHANGED = "FLOORPLAN_STATE_VISIBILITY_CHANGED",
  FLOORPLAN_STATE_ITEM_TEXT_VISIBILITY_CHANGED = "FLOORPLAN_STATE_ITEM_TEXT_VISIBILITY_CHANGED",
  FREE_TEXT_ADDED = "FREE_TEXT_ADDED",
  FREE_TEXT_DELETED = "FREE_TEXT_DELETED",
  FREE_TEXT_UPDATED = "FREE_TEXT_UPDATED",
  FREE_TEXTS_ITEM_TEXT_VISIBILITY_CHANGED = "FREE_TEXTS_ITEM_TEXT_VISIBILITY_CHANGED",
  GAS_WARNING_CENTER_ADDED = "GAS_WARNING_CENTER_ADDED",
  GAS_WARNING_CENTER_DELETED = "GAS_WARNING_CENTER_DELETED",
  GAS_WARNING_CENTERS_ITEM_TEXT_VISIBILITY_CHANGED = "GAS_WARNING_CENTERS_ITEM_TEXT_VISIBILITY_CHANGED",
  GAS_WARNING_CENTER_PLACEHOLDER_ADDED = "GAS_WARNING_CENTER_PLACEHOLDER_ADDED",
  GAS_WARNING_CENTER_PLACEHOLDER_DELETED = "GAS_WARNING_CENTER_ADDED_PLACEHOLDER_DELETED",
  GROUP_ADDED = "GROUP_ADDED",
  GROUP_DELETED = "GROUP_DELETED",
  GROUP_DESELECTED = "GROUP_DESELECTED",
  GROUP_PRODUCT_ADDED = "GROUP_PRODUCT_ADDED",
  GROUP_PRODUCT_REMOVED = "GROUP_PRODUCT_REMOVED",
  GROUP_SELECTED = "GROUP_SELECTED",
  IMAGE_ADDED = "IMAGE_ADDED",
  IMAGE_DELETED = "IMAGE_DELETED",
  IMAGES_ITEM_TEXT_VISIBILITY_CHANGED = "IMAGES_ITEM_TEXT_VISIBILITY_CHANGED",
  ITEM_DISPLAY_NAME_CHANGED = "ITEM_DISPLAY_NAME_CHANGED",
  ITEM_LOCK_CHANGED = "ITEM_LOCK_CHANGED",
  ITEM_TEXT_VISIBILITY_CHANGED = "ITEM_TEXT_VISIBILITY_CHANGED",
  ITEM_POSITION_ID_CHANGED = "ITEM_POSITION_ID_CHANGED",
  ITEM_SIZE_CHANGED = "ITEM_SIZE_CHANGED",
  ITEM_SIZE_CHANGED_BY_INPUT = "ITEM_SIZE_CHANGED_BY_INPUT",
  ITEM_UPDATED = "ITEM_UPDATED",
  MEASUREMENT_LINE_ADDED = "MEASUREMENT_LINE_ADDED",
  MEASUREMENT_LINE_DELETED = "MEASUREMENT_LINE_DELETED",
  MEASUREMENT_LINE_UPDATED = "MEASUREMENT_LINE_UPDATED",
  MEASUREMENT_LINES_ITEM_TEXT_VISIBILITY_CHANGED = "MEASUREMENT_LINES_ITEM_TEXT_VISIBILITY_CHANGED",
  MONITORING_AREA_RADIUS_UPDATED = "MONITORING_AREA_RADIUS_UPDATED",
  REFERENCE_MEASURE_ADDED = "REFERENCE_MEASURE_ADDED",
  REFERENCE_MEASURE_DELETED = "REFERENCE_MEASURE_DELETED",
  REFERENCE_MEASURE_UPDATED = "REFERENCE_MEASURE_UPDATED",
  REFERENCE_MEASURE_RESET = "REFERENCE_MEASURE_RESET",
  REFERENCE_MEASURE_ITEM_TEXT_VISIBILITY_CHANGED = "REFERENCE_MEASURE_ITEM_TEXT_VISIBILITY_CHANGED",
  PIPELINE_ADDED = "PIPELINE_ADDED",
  PIPELINE_DELETED = "PIPELINE_DELETED",
  PIPELINES_ITEM_TEXT_VISIBILITY_CHANGED = "PIPELINES_ITEM_TEXT_VISIBILITY_CHANGED",
  PLASTIC_SIGN_ADDED = "PLASTIC_SIGN_ADDED",
  PLASTIC_SIGN_DELETED = "PLASTIC_SIGN_DELETED",
  PLASTIC_SIGNS_ITEM_TEXT_VISIBILITY_CHANGED = "PLASTIC_SIGNS_ITEM_TEXT_VISIBILITY_CHANGED",
  PLASTIC_SIGN_PLACEHOLDER_ADDED = "PLASTIC_SIGN_PLACEHOLDER_ADDED",
  PLASTIC_SIGN_PLACEHOLDER_DELETED = "PLASTIC_SIGN_PLACEHOLDER_DELETED",
  PROTECTIVE_TUBE_ADDED = "PROTECTIVE_TUBE_ADDED",
  PROTECTIVE_TUBE_DELETED = "PROTECTED_TUBE_DELETED",
  PROTECTIVE_TUBES_ITEM_TEXT_VISIBILITY_CHANGED = "PROTECTIVE_TUBES_ITEM_TEXT_VISIBILITY_CHANGED",
  REMOTE_SENSOR_ATTACHED = "REMOTE_SENSOR_ATTACHED",
  REMOTE_SENSOR_DETACHED = "REMOTE_SENSOR_DETACHED",
  SIGNAL_ELEMENT_ADDED = "SIGNAL_ELEMENT_ADDED",
  SIGNAL_ELEMENT_DELETED = "SIGNAL_ELEMENT_DELETED",
  SIGNAL_ELEMENTS_ITEM_TEXT_VISIBILITY_CHANGED = "SIGNAL_ELEMENTS_ITEM_TEXT_VISIBILITY_CHANGED",
  SIGNAL_ELEMENT_PLACEHOLDER_ADDED = "SIGNAL_ELEMENT_PLACEHOLDER_ADDED",
  SIGNAL_ELEMENT_PLACEHOLDER_DELETED = "SIGNAL_ELEMENT_PLACEHOLDER_DELETED",
  TEXT_ADDED = "TEXT_ADDED",
  TEXT_DELETED = "TEXT_DELETED",
  TEXTS_ITEM_TEXT_VISIBILITY_CHANGED = "TEXTS_ITEM_TEXT_VISIBILITY_CHANGED",
  TRANSMITTER_ADDED = "TRANSMITTER_ADDED",
  TRANSMITTER_DELETED = "TRANSMITTER_DELETED",
  TRANSMITTERS_ITEM_TEXT_VISIBILITY_CHANGED = "TRANSMITTERS_ITEM_TEXT_VISIBILITY_CHANGED",
  TRANSMITTER_PLACEHOLDER_ADDED = "TRANSMITTER_PLACEHOLDER_ADDED",
  TRANSMITTER_PLACEHOLDER_DELETED = "TRANSMITTER_PLACEHOLDER_DELETED",
  WILDCARD_ZONE_ADDED = "WILDCARD_ZONE_ADDED",
  WILDCARD_ZONE_DELETED = "WILDCARD_ZONE_DELETED",
  WILDCARD_ZONES_ITEM_TEXT_VISIBILITY_CHANGED = "WILDCARD_ZONES_ITEM_TEXT_VISIBILITY_CHANGED",
  WIRE_ADDED = "WIRE_ADDED",
  WIRE_DELETED = "WIRE_DELETED",
  WIRES_ITEM_TEXT_VISIBILITY_CHANGED = "WIRES_ITEM_TEXT_VISIBILITY_CHANGED",
  PATIENT_MONITOR_ADDED = "PATIENT_MONITOR_ADDED",
  PATIENT_MONITOR_DELETED = "PATIENT_MONITOR_DELETED",
  PATIENT_MONITORS_ITEM_TEXT_VISIBILITY_CHANGED = "PATIENT_MONITORS_ITEM_TEXT_VISIBILITY_CHANGED",
  PATIENT_MONITOR_PLACEHOLDER_ADDED = "PATIENT_MONITOR_PLACEHOLDER_ADDED",
  PATIENT_MONITOR_PLACEHOLDER_DELETED = "PATIENT_MONITOR_PLACEHOLDER_DELETED",
  CENTRAL_STATION_ADDED = "CENTRAL_STATION_ADDED",
  CENTRAL_STATION_DELETED = "CENTRAL_STATION_DELETED",
  CENTRAL_STATIONS_ITEM_TEXT_VISIBILITY_CHANGED = "CENTRAL_STATION_ITEM_TEXT_VISIBILITY_CHANGED",
  CENTRAL_STATION_PLACEHOLDER_ADDED = "CENTRAL_STATION_PLACEHOLDER_ADDED",
  CENTRAL_STATION_PLACEHOLDER_DELETED = "CENTRAL_STATION_PLACEHOLDER_DELETED",
  TELEMETRY_ADDED = "TELEMETRY_ADDED",
  TELEMETRY_DELETED = "TELEMETRY_DELETED",
  TELEMETRIES_ITEM_TEXT_VISIBILITY_CHANGED = "TELEMETRIES_ITEM_TEXT_VISIBILITY_CHANGED",
  TELEMETRY_PLACEHOLDER_ADDED = "TELEMETRY_PLACEHOLDER_ADDED",
  TELEMETRY_PLACEHOLDER_DELETED = "TELEMETRY_PLACEHOLDER_DELETED",
  KVM_ADDED = "KVM_ADDED",
  KVM_RECEIVERS_UPDATED = "KVM_RECEIVERS_UPDATED",
  KVM_DELETED = "KVM_DELETED",
  KVMS_ITEM_TEXT_VISIBILITY_CHANGED = "KVM_ITEM_TEXT_VISIBILITY_CHANGED",
  KVM_PLACEHOLDER_ADDED = "KVM_PLACEHOLDER_ADDED",
  KVM_PLACEHOLDER_DELETED = "KVM_PLACEHOLDER_DELETED",
  DISPLAY_ADDED = "DISPLAY_ADDED",
  DISPLAY_DELETED = "DISPLAY_DELETED",
  DISPLAYS_ITEM_TEXT_VISIBILITY_CHANGED = "DISPLAYS_ITEM_TEXT_VISIBILITY_CHANGED",
  DISPLAY_PLACEHOLDER_ADDED = "DISPLAY_PLACEHOLDER_ADDED",
  DISPLAY_PLACEHOLDER_DELETED = "DISPLAY_PLACEHOLDER_DELETED",
  UTILITY_ADDED = "UTILITY_ADDED",
  UTILITY_DELETED = "UTILITY_DELETED",
  UTILITIES_ITEM_TEXT_VISIBILITY_CHANGED = "UTILITIES_ITEM_TEXT_VISIBILITY_CHANGED",
  UTILITY_PLACEHOLDER_ADDED = "UTILITY_PLACEHOLDER_ADDED",
  UTILITY_PLACEHOLDER_DELETED = "UTILITY_PLACEHOLDER_DELETED",
  ISOLATION_ROOM_ADDED = "ISOLATION_ROOM_ADDED",
  ISOLATION_ROOM_DELETED = "ISOLATION_ROOM_DELETED",
  ISOLATION_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED = "ISOLATION_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED",
  IT_ROOM_ADDED = "IT_ROOM_ADDED",
  IT_ROOM_DELETED = "IT_ROOM_DELETED",
  IT_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED = "IT_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED",
  OPERATING_THEATRE_ADDED = "OPERATING_THEATRE_ADDED",
  OPERATING_THEATRE_DELETED = "OPERATING_THEATRE_DELETED",
  OPERATING_THEATRES_ITEM_TEXT_VISIBILITY_CHANGED = "OPERATING_THEATRES_ITEM_TEXT_VISIBILITY_CHANGED",
  PROCEDURE_ROOM_ADDED = "PROCEDURE_ROOM_ADDED",
  PROCEDURE_ROOM_DELETED = "PROCEDURE_ROOM_DELETED",
  PROCEDURE_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED = "PROCEDURE_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED",
  STANDARD_ROOM_ADDED = "STANDARD_ROOM_ADDED",
  STANDARD_ROOM_DELETED = "STANDARD_ROOM_DELETED",
  STANDARD_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED = "STANDARD_ROOMS_ITEM_TEXT_VISIBILITY_CHANGED",
}

export interface FloorplanEvent {
  project: ScopedProject;
  floorplan: Floorplan;
  type: FloorplanEventType;
  subject: any;
}
